import React, { memo, useEffect, useState, useCallback } from 'react';
import { useInView } from 'react-intersection-observer';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import styles from './GameThreeRank.module.less';
import GameRankItem from '../../components/Game/GameRankItem/GameRankItem';
import { logging, logPostInfo } from '../../actions/log';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ data, logInfo }) => {
  const dispatch = useDispatch();
  const [showNum, setShowNum] = useState(3);
  const logInfoData = useSelector(selectLogInfo);
  const [refInview, inView] = useInView({
    threshold: 0,
  });

  useEffect(() => {
    window.addEventListener('resize', handleResize, false);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // useEffect(() => {
  //   if (inView75 && logInfo && logInfo.changView) {
  //     data.dataList.forEach(el => {
  //       logInfo.changView({
  //         ...logInfo,
  //         pageCardTitle: data && data.title,
  //         cardType: data && data.cardType,
  //         pageCardId: el.pageCardId,
  //         rankCode: el.rankCode,
  //         org: el.org || '',
  //       });
  //     });
  //   }
  // }, [inView75]);

  const handleResize = useCallback(() => {
    const clientWidth = (document.body && document.body.clientWidth) || 1060;
    if (clientWidth >= 1060 && clientWidth < 1331) {
      setShowNum(3);
    } else if (clientWidth >= 1331 && clientWidth < 1602) {
      setShowNum(4);
    } else if (clientWidth >= 1602 && clientWidth < 1873) {
      setShowNum(5);
    } else if (clientWidth >= 1873) {
      setShowNum(6);
    }
  }, []);

  return (
    <div
      ref={refInview}
      className={`${styles.card} ${inView ? styles.card_cardIn : styles.card_cardOut}`}
    >
      {inView && (
        <div className={styles.game_three_rank}>
          <div className="title">{data.title}</div>
          <div className="three_rank_info">
            {data.dataList.slice(0, showNum).map((item, index) => (
              <GameRankItem
                indexKey={index}
                key={index}
                rankInfo={item}
                logInfo={logInfo}
                data={data}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
});
